const setLinkTag = (rel: string, href: string): (() => void) => {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`)
  const created = !el
  if (!el) {
    el = document.createElement("link")
    el.setAttribute("rel", rel)
    document.head.appendChild(el)
  }
  const prevHref = el.getAttribute("href")
  el.setAttribute("href", href)
  return () => {
    if (created) el.remove()
    else if (prevHref !== null) el.setAttribute("href", prevHref)
  }
}

export default setLinkTag
